var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "module"
  }, [_c("div", {
    staticClass: "module-main"
  }, [_c("div", {
    staticClass: "module-img",
    style: {
      float: _vm.layout
    }
  }, [_c("img", {
    attrs: {
      src: _vm.img,
      alt: "images"
    }
  })]), _c("div", {
    staticClass: "module-text",
    style: {
      paddingLeft: _vm.layout === "left" ? "56px" : "0",
      paddingRight: _vm.layout === "left" ? "0" : "56px"
    }
  }, [_c("h3", [_vm._v(_vm._s(_vm.title))]), _c("p", [_vm._v(_vm._s(_vm.desc1))]), _c("p", [_vm._v(_vm._s(_vm.desc2))])])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };